import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Menu from "../Menu";
import { logout } from "../../../actions/auth";
import { useDispatch } from "react-redux";
import { decryptPermissions } from "../../../utils/permissionsHelpers";

const PermissionDeniedDialog = ({ isOpen }) => {
  // styles
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpenDialog, setIsOpenDialog] = useState(isOpen);
  const permissions = decryptPermissions();

  const handleNavigation = () => {
    setIsOpenDialog(false);
    if (permissions?.length) {
      navigate(-1);
    } else {
      dispatch(logout());
      navigate("/login");
    }
  };

  return (
    <>
      <Navbar />
      <Grid className="app-content">
        <Menu />
        <Grid className="page-content">
          <Dialog maxWidth={false} open={isOpenDialog}>
            <DialogTitle align="center">Permission Denied</DialogTitle>
            <DialogContent dividers={true}>
              You do not have permission to this page
            </DialogContent>
            <DialogActions>
              <Button onClick={handleNavigation} variant="outlined">
                {permissions?.length ? "Go Back" : "Logout"}
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
      </Grid>
    </>
  );
};
export default PermissionDeniedDialog;
